import { Box, Inline, Stack, Text } from 'braid-design-system';
import type { FC, ReactElement } from 'react';

import { ModalTitle } from '../Modal';

import * as styles from './ImageModalContent.css';

interface ImageModalContentProps {
  actions: ReactElement;
  content: ReactElement;
  heading: string;
  subheading?: string;
  titleId: string;
}

export const ImageModalContent: FC<ImageModalContentProps> = ({
  actions,
  content,
  heading,
  subheading,
  titleId,
}) => (
  <Stack space={['medium', 'large']}>
    <Stack space={['medium', 'large']}>
      <Stack space="small">
        <ModalTitle component="h4" id={titleId}>
          {heading}
        </ModalTitle>
        {subheading ? <Text size="small">{subheading}</Text> : null}
      </Stack>
      {content}
    </Stack>
    <Box className={styles.actions}>
      <Inline space="xsmall" collapseBelow="tablet">
        {actions}
      </Inline>
    </Box>
  </Stack>
);
